import { FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { useGetTruckerQueriesData } from 'hooks/useGetTruckerQueriesData';
import React from 'react';
import DraggableScroll from '../DraggableScroll';

const Achievements: React.FC = () => {
  const { truckerData } = useGetTruckerQueriesData();

  return (
    <>
      <FuelTypography
        size="heading-sm"
        weight="bold"
        color="neutral-strong"
        data-testid="achievements-title"
        spacingLeft={32}
        spacingTop={16}
      >
        Conquistas
      </FuelTypography>

      <DraggableScroll
        listGap={DS_TOKENS.spacing.km2}
        listPadding={`${DS_TOKENS.spacing.km6} ${DS_TOKENS.spacing.km8} ${DS_TOKENS.spacing.km4}`}
      >
        {truckerData?.stamps?.position
          .filter((achievement) => achievement.value === true)
          .map((achievement) => (
            <FuelFlex
              defaultProps={{
                display: 'flex',
                width: '100%',
                minWidth: '150px',
                maxWidth: 'calc(100% / 3)',
                minHeight: '144px',
                gap: 'km2',
                borderRadius: 'small',
                borderWidth: 'thinner',
                borderStyle: 'solid',
                borderColor: DS_TOKENS.color.border.neutral.default,
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                padding: 'km2',
              }}
              key={achievement.key}
            >
              <FuelSign icon={achievement.icon} iconStyle={achievement.iconStyled} color="inverted" size="medium" />
              <FuelFlex defaultProps={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <FuelTypography weight="medium" size="body-sm">
                  {achievement.title}
                </FuelTypography>
                <FuelTypography weight="medium" size="caption" color="neutral-default">
                  {achievement.subtitle}
                </FuelTypography>
              </FuelFlex>
            </FuelFlex>
          ))}
      </DraggableScroll>
    </>
  );
};

export default Achievements;
